import StatsStrip from "@common/components/StatsStrip";
import { Link } from "react-router-dom";
import { buttonClass } from "@jkast90/kast-common/ui";
import cta from "@common/components/cta.module.css";
import styles from "./HomePage.module.css";

export default function HomePage() {
  return (
    <>
      <section className={styles.hero}>
        <img
          src="https://hashersnottrashers.org/wp-content/uploads/2024/11/forest_sun.jpeg"
          alt="Hashers Not Trashers"
          className={styles.heroImage}
        />
        <div className={styles.heroOverlay}>
          <h1 className={styles.heroTitle}>Hashers for a cleaner world</h1>
          <p className={styles.heroSubtitle}>
            A massive litter pick-up movement to keep outdoor spaces sustainable and healthy.
          </p>
          <div className={styles.heroCtas}>
            <Link to="/work-with-us" className={buttonClass({ variant: "primary", size: "lg", className: cta.cta })}>
              Donate
            </Link>
            <Link to="/about" className={buttonClass({ variant: "secondary", size: "lg" })}>
              About Us
            </Link>
          </div>
        </div>
      </section>

      <section className={styles.stats} aria-label="Our impact in numbers">
        <StatsStrip />
      </section>

      <section className={styles.content}>
        <h2>What We Do</h2>
        <p>
          We are committed to environmental improvements of change and a sustainable future for present and generations
          to come. Litter pollution on land and in the ocean, improved recycling measures, and a focus on the natural
          habitat.
        </p>
        <p>
          We're an international 501(c)3. A non-profit organization with a worldwide community dedicated to keeping our
          neighborhoods, parks, beaches, mountains, rivers, oceans, and open places cleaner and safer.
        </p>
      </section>
    </>
  );
}
